import TagPicker from './TagPicker';

// export types
export type { TagPickerProps } from './TagPicker';

// export components
export { TagPicker };
export default TagPicker;
